import Parser from 'ua-parser-js';

export const getMajorVersion = (version: string) => {
  return parseInt(version.split('.')[0]);
};

export const isSupportedMajorVersion = (
  majorVersion: number,
  oldestSupportedMajorVersion: number,
) => {
  return majorVersion >= oldestSupportedMajorVersion;
};

export const isChrome = (name: string) => {
  return name === 'Chrome' || name === 'Chromium';
};

export const isSupportedChrome = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 80);
};

export const isFirefox = (name: string) => {
  return name === 'Firefox';
};

export const isSupportedFirefox = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 72);
};

export const isSafari = (name: string) => {
  return name === 'Safari' || name === 'Mobile Safari';
};

export const isSupportedSafari = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 14);
};

export const isEdge = (name: string) => {
  return name === 'Edge';
};

export const isSupportedEdge = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 88);
};

export const isOpera = (name: string) => {
  return name === 'Opera' || name === 'OPR';
};

export const isSupportedOpera = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 67);
};

export const isOperaMini = (name: string) => {
  return name === 'Opera Mini';
};

export const isSupportedOperaMini = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 46);
};

export const isWebKit = (name: string) => {
  return name === 'WebKit';
};

export const isSupportedWebKit = (majorVersion: number) => {
  return isSupportedMajorVersion(majorVersion, 609);
};

export const isSupportedBrowser = (userAgentString: string) => {
  const parsed = new Parser(userAgentString);
  const { name, version } = parsed.getBrowser();

  if (!name || !version) {
    return false;
  }

  const majorVersion = getMajorVersion(version);

  if (isChrome(name)) {
    return isSupportedChrome(majorVersion);
  } else if (isFirefox(name)) {
    return isSupportedFirefox(majorVersion);
  } else if (isSafari(name)) {
    return isSupportedSafari(majorVersion);
  } else if (isEdge(name)) {
    return isSupportedEdge(majorVersion);
  } else if (isOpera(name)) {
    return isSupportedOpera(majorVersion);
  } else if (isOperaMini(name)) {
    return isSupportedOperaMini(majorVersion);
  } else if (isWebKit(name)) {
    return isSupportedWebKit(majorVersion);
  } else {
    return false;
  }
};
